import { useAiAgentStore, DEFAULT_CHAT_SOURCE_SETTINGS } from "@/stores/ai-agent";
import SettingIcon from "../ui/icons/SettingIcon";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Switch } from "../ui/switch";
import { Text } from "../ui/text";
import { JobSelectTrigger } from "./job-select-dialog";
import { useState } from "react";

interface SourceSelectPopoverProps {
  /** 현재 채팅방 ID (홈/새채팅은 "temp") */
  chatId: string;
  disabled?: boolean;
}

const SourceSelectPopover = ({ chatId, disabled = false }: SourceSelectPopoverProps) => {
  // chatSourceSettingsMap에서 직접 구독 → Map 변경 시 리렌더 보장
  const settings = useAiAgentStore(
    (state) => state.chatSourceSettingsMap.get(chatId) ?? DEFAULT_CHAT_SOURCE_SETTINGS
  );
  const setChatSourceSetting = useAiAgentStore((state) => state.setChatSourceSetting);

  const { deepResearch, webSearchEnabled, academicJournalEnabled } = settings;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover open={disabled ? false : isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <button
          disabled={disabled}
          className={`relative overflow-hidden rounded-lg
             backdrop-blur-sm active:scale-[0.98]
             transition-all
             duration-200
             ease-in-out
            ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
          style={{
            boxShadow: "0 4px 10px 0 rgba(55, 55, 55, 0.05)",
          }}
        >
          <div
            className="
          flex
          items-center
          justify-center
          
        "
            style={{
              background: "rgba(255, 255, 255, 0.50)",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "0px",
              borderBottomLeftRadius: "0px",
              borderBottomRightRadius: "8px",
              border: "1px solid rgba(255, 255, 255, 0.8)",
            }}
          >
            <div className="w-[40px] h-[40px] flex justify-center items-center">
              <SettingIcon color={isOpen ? "#1DB3A4" : "#4D4D4D"} />
            </div>
          </div>
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-[220px] flex flex-col gap-[2px] px-1 pt-3 pb-4 rounded-[10px]"
        align="start"
        sideOffset={13}
      >
        <div className="h-[40px] px-4 flex items-center gap-[15px]">
          <Text
            variant={"label-lg"}
            className="text-grey-20 whitespace-nowrap flex-1 min-w-0"
          >
            Deep Research
          </Text>
          <Switch
            className="data-[state=checked]:bg-primary-30 h-[28px] flex-shrink-0"
            checked={deepResearch}
            onCheckedChange={(v) =>
              setChatSourceSetting(chatId, "deepResearch", v)
            }
          />
        </div>
        <div className="bg-grey-90 h-[1px] m-4 mb-0"></div>
        <div className="h-[40px] px-4 flex items-center">
          <Text variant={"title-lg"} className="text-grey-20">
            Source
          </Text>
        </div>
       {/* 2026/1/15 Public Journal 버튼 비활성화 */}
        {/* <div className="h-[40px] px-4 flex justify-between items-center">
          <Text variant={"label-lg"} className="text-grey-20">
            Public Journal
          </Text>
          <Switch
            className="data-[state=checked]:bg-primary-30 h-[28px]"
            checked={biomcpEnabled}
            onCheckedChange={setBiomcpEnabled}
          />
        </div> */}
        <div className="h-[40px] px-4 flex items-center gap-[15px]">
          <Text
            variant={"label-lg"}
            className="text-grey-20 whitespace-nowrap flex-1 min-w-0"
          >
            Academic Journal
          </Text>
          <Switch
            className="data-[state=checked]:bg-primary-30 h-[28px] flex-shrink-0"
            checked={academicJournalEnabled}
            onCheckedChange={(v) =>
              setChatSourceSetting(chatId, "academicJournalEnabled", v)
            }
          />
        </div>
        <div className="h-[40px] px-4 flex items-center gap-[15px]">
          <Text
            variant={"label-lg"}
            className="text-grey-20 whitespace-nowrap flex-1 min-w-0"
          >
            Web Search
          </Text>
          <Switch
            className="data-[state=checked]:bg-primary-30 h-[28px] flex-shrink-0"
            checked={webSearchEnabled}
            onCheckedChange={(v) =>
              setChatSourceSetting(chatId, "webSearchEnabled", v)
            }
          />
        </div>
        <div className="bg-grey-90 h-[1px] m-4"></div>
        <div className="flex justify-center">
          <JobSelectTrigger onClick={() => setIsOpen(false)} />
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default SourceSelectPopover;
